<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Обращения </span>
        <!-- <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false" color="var(--app-dark-blue-1)">mdi-information</v-icon> -->
      </div>
      <v-btn @click="goToCreate" style="width: auto !important" class="button-accept">
        + Добавить сотрудника
      </v-btn>
    </div>

    <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
      <v-card min-width="300px" min-height="100px">
        <div class="menu-container">
          <div class="menu-container-title">
            «Состав консультационного совета акционеров»
          </div>
          <div class="menu-container-text">
            Список акционеров, который отображается в мобильном приложении
          </div>
        </div>
      </v-card>
    </v-menu>

    <div style="height: calc(100vh - 190px); overflow: auto">
      <v-data-table :headers="tableHeaders" :items="items" item-key="id" :show-select="false" :disable-pagination="true"
        :hide-default-footer="true" :hide-default-header="true">
        <template v-slot:header>
          <thead>
            <tr>
              <th v-for="(s, index) in tableHeaders" :key="index">
                <div style="margin-left: 24px" v-if="s.text == 'ФИО'">
                  {{ s.text }}
                </div>
                <div style="max-width: 100px !important" v-else-if="s.text == 'Порядок отображения'">
                  {{ s.text }}
                </div>
                <div v-else>
                  {{ s.text }}
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="props">
          <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''">
            <tr v-for="(item, index) in props.items" :key="index" @click="goToDetail(item)">
              <td>
                <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                  mdi-menu
                </v-icon>
              </td>
              <td>{{ index + 1 }}</td>
              <td>
                <div class="d-flex align-center">
                  <v-icon v-if="item.isHidden" small> mdi-eye-off </v-icon>
                  <div v-else style="width: 24px"></div>
                  <div :style="item.isHidden ? 'margin-left: 8px' : ''">
                    {{ item.fullName }}
                  </div>
                </div>
              </td>
              <td>{{ item.position }}</td>
              <td>
                <div class="mb-2" v-for="(i, ind) in item.emails" :key="ind">
                  {{ i }}
                </div>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    items: [],
    moveItems: false,
    selectedDrag: "",
    tableHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "Порядок отображения",
        value: "",
        sortable: false,
      },
      {
        text: "ФИО",
        sortable: false,
        value: "fullName",
      },
      {
        text: "Должность",
        sortable: false,
        value: "position",
      },
      {
        text: "Эл. почта",
        sortable: false,
        value: "emails",
      },
    ],
  }),
  methods: {
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    goToCreate() {
      this.$router.push({ name: "AppealUserCreate" });
    },

    goToDetail(item) {
      this.$router.push({ name: "AppelaUserDetail", params: { id: item.id } });
    },
    getItems() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/appeal/employee/list", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
          params: { page: 1, limit: 100 },
        })
        .then((res) => {
          this.items = res.data.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    endDrag(evt) {
      this.moveItems = true;
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/appeal/employee/sort",
          {
            appealEmployeeId: this.selectedDrag,
            index: evt.newIndex + 1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.getItems();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.moveItems = false;
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
  },
  created() {
    this.getItems();
  },
};
</script>
<style lang="scss" scoped></style>